import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useApp } from '@/context/AppContext';
import { CheckCircle, ChevronRight, RotateCcw } from 'lucide-react';

export default function MedicionResultadoStep() {
  const navigate = useNavigate();
  const { state } = useApp();
  const { maskSizing, maskRecommendation } = state.eleccion;

  // Handle header back button clicks
  useEffect(() => {
    const handleHeaderBack = () => {
      // Go back to the measurement step
      navigate('/eleccion/medicion');
    };

    window.addEventListener('headerBackClick', handleHeaderBack);
    return () => window.removeEventListener('headerBackClick', handleHeaderBack);
  }, [navigate]);

  // Redirect if no mask sizing data
  useEffect(() => {
    if (!maskSizing) {
      navigate('/eleccion/medicion');
    }
  }, [maskSizing, navigate]);

  if (!maskSizing) {
    return null;
  }

  const selectedSize = {'S': 'Pequeña', 'M': 'Mediana', 'L': 'Grande'}[maskSizing.maskSize];
  const continuarAFelicitaciones = () => {
    navigate('/eleccion/felicitaciones');
  };

  const redoSizing = () => {
    navigate('/eleccion/medicion');
  };

  return (
    <div className="min-h-screen bg-soft-bg">
      <div className="container px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <CheckCircle className="h-12 w-12 text-primary mx-auto mb-6" />
            <h1 className="text-3xl font-bold text-primary mb-2">
              {maskSizing.measureMethod === 'regla' 
                ? `Te corresponde la talla ${selectedSize.toLowerCase()}` 
                : `Talla ${selectedSize.toLowerCase()} seleccionada`}
            </h1>
          </div>

          <div className="mt-6 space-y-3">
            <Button className="min-h-touch px-6 sm:px-8 gap-0 w-full text-lg" onClick={continuarAFelicitaciones}>
              <span className="">{maskSizing.measureMethod === 'regla' ? 'Continuar con esta talla' : 'Continuar'}</span>
              <ChevronRight style={{ marginLeft: '2.5px', width: '1.25rem', height: '1.25rem', strokeWidth: '3px'}}/>
            </Button>
            
            <Button 
              variant="outline"
              onClick={redoSizing} 
              className="w-full text-lg gap-2"
            >
              <RotateCcw className="h-4 w-4" />
              Rehacer este segmento
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}